import { SET_APP_EDITABLE, SET_IS_APPROVER_USER } from '../../types/appConstants'

// **  Initial State
const initialState = {
  isAppEditable: false,
  isApproverUser: false
}

const appeditable = (state = initialState, action) => {
  switch (action.type) {
    case SET_APP_EDITABLE:
      return { ...state, isAppEditable: action.payload }
    case SET_IS_APPROVER_USER:
      return { ...state, isApproverUser: action.payload }
    default:
      return state
  }
}

export default appeditable
